import React from 'react'
import { HelpDrawerWithAccordion } from '@labrav/common'
import { notificationsImages } from '../../../../../common/utils/productCreationUtil'
import {
  FaqQuestion,
  FlyoutProductCreationFaqSection,
  HelpDrawerFaqItems,
} from '../../../../AddEditProductFormComponents/FlyoutProductFormHelpFaqs/ProductCreationFaqUtil'
import { CarouselWithModal } from '../../../../../common/components/CarouselWithModal/CarouselWithModal'

const faqItems: HelpDrawerFaqItems[] = [
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.NOTIFICATIONS_LISTING_NOTIFICATIONS
        }
        question="What does Listing live on AWS Marketplace notify me about?"
      />
    ),
    answer: (
      <div>
        When your listing has been tested by AWS Marketplace and approved by
        them, only then does the listing become public. The email for listing
        live on AWS Marketplace will notify you on the exact moment when your
        listing becomes public.
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.NOTIFICATIONS_LISTING_NOTIFICATIONS
        }
        question="What does Listing rejected by AWS Marketplace notify me about?"
      />
    ),
    answer: (
      <div>
        If after testing by the AWS Marketplace team, your listing or your
        product is not in line with the AWS mentioned guidelines then your
        listing may be rejected. The AWS team will cite the reason of rejection
        and also mention any changes which need to be made in the listing. Labra
        will notify you if your listing is ever rejected and the action which
        needs to be taken to make the listing public.
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.NOTIFICATIONS_LISTING_NOTIFICATIONS
        }
        question="What does Free trial activated let me know?"
      />
    ),
    answer: (
      <div>
        When any buyer who purchases your product thereafter activates their
        Free trial provided in the listing you will be notified via email
        regarding it.
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.NOTIFICATIONS_LISTING_NOTIFICATIONS
        }
        question="What does Free trial deactivated let me know?"
      />
    ),
    answer: (
      <div>
        When a buyer who had previously activated a free trial in your product
        thereafter deactivates it or their free trial ends, you will recieve an
        email notification from Labra regarding it.
      </div>
    ),
  },
]

interface ListingNotificationFaqsProps {
  indexModal: number
  setIndexModal: (index: number) => void
}

export const ListingNotificationFaqs: React.FC<
  ListingNotificationFaqsProps
> = ({ indexModal, setIndexModal }) => (
  <HelpDrawerWithAccordion
    headerTitle="Help & FAQs - Listing Notifications"
    faqItems={faqItems}
    customContent={
      <CarouselWithModal
        carouselData={notificationsImages}
        setCurrentIndex={setIndexModal}
        currentIndex={indexModal}
      />
    }
  />
)
